import * as generalChatActions from '@actions/general-chat';

const initialState = {
    chatId: null,
    caseId: null,

    search: '',
    currentPage: undefined,
    lastPage: 1,

    readMessages: [],
    unreadMessages: [],

    getChatDataRequest: {
        isProcessing: false,
        error: null,
    },

    sendMessageRequest: {
        isProcessing: false,
        error: null,
    },
};

const generalChat = (state = initialState, action) => {
    switch (action.type) {
        case generalChatActions.SET_GENERAL_CHAT_DATA:
            const { caseId, id, read_messages: readMessages, unread_messages } = action.payload;
            const { current_page: currentPage, last_page: lastPage } = readMessages;

            return {
                ...state,
                caseId: caseId,
                chatId: id,
                currentPage,
                lastPage,
                readMessages: [...readMessages.data.filter(({ id }) => !state.readMessages.find(message => message.id === id)), ...state.readMessages],
                unreadMessages: unread_messages,
            };
        case generalChatActions.SET_IS_GET_CHAT_REQUEST_PROCESSING: {
            return {
                ...state,
                getChatDataRequest: {
                    ...state.getChatDataRequest,
                    isProcessing: action.payload,
                },
            };
        }
        case generalChatActions.READ_MESSAGES: {
            const readMessages = state.unreadMessages.filter(({ id }) => action.payload.includes(id));
            const unreadMessages = state.unreadMessages.filter(({ id }) => !action.payload.includes(id));

            return {
                ...state,
                readMessages: [...state.readMessages, ...readMessages],
                unreadMessages,
            };
        }
        case generalChatActions.SET_IS_SEND_MESSAGE_REQUEST_PROCESSING: {
            return {
                ...state,
                sendMessageRequest: {
                    ...state.sendMessageRequest,
                    isProcessing: action.payload,
                },
            };
        }
        case generalChatActions.SET_SEND_MESSAGE_REQUEST_ERROR: {
            return {
                ...state,
                sendMessageRequest: {
                    ...state.sendMessageRequest,
                    error: action.payload,
                },
            };
        }
        case generalChatActions.SEND_MESSAGE: {
            return {
                ...state,
                readMessages: [...(state.readMessages || []), ...(state.unreadMessages || []), action.payload],
                unreadMessages: [],
            };
        }
        case generalChatActions.ADD_NEW_UNREAD_MESSAGE: {
            if (!state.readMessages.find(({ id }) => id === action.payload.id) && !state.unreadMessages.find(({ id }) => id === action.payload.id)) {
                return {
                    ...state,
                    unreadMessages: [...state.unreadMessages, action.payload],
                };
            }

            return state;
        }
        // Кейс когда из другой вкладки приходит наше сообщение в вебсокетах
        case generalChatActions.ADD_NEW_READ_MESSAGE: {
            if (!state.readMessages.find(({ id }) => id === action.payload.id) && !state.unreadMessages.find(({ id }) => id === action.payload.id)) {
                return {
                    ...state,
                    readMessages: [...state.readMessages, action.payload],
                };
            }

            return state;
        }
        // Нужно в любом случае пометить сообщения прочитанными и перенести прочитанные из непрочитанных, если такие есть
        case generalChatActions.SET_MESSAGES_READ: {
            return {
                ...state,
                readMessages: [
                    // Помечаем нами прочитанные сообщения - прочитанными
                    ...state.readMessages.map(message => ({
                        ...message,
                        is_another_user_read: message.is_another_user_read || action.payload.includes(message.id),
                    })),
                    // Добавляем прочитанные сообщения из непрочитанных
                    ...state.unreadMessages
                        .filter(({ id }) => action.payload.includes(id))
                        .map(message => ({
                            ...message,
                            is_another_user_read: message.is_another_user_read || action.payload.includes(message.id),
                        })),
                ],
                // Убираем прочитанные сообщения из непрочитанных
                unreadMessages: state.unreadMessages.filter(({ id }) => !action.payload.includes(id)),
            };
        }
        case generalChatActions.SET_SEARCH: {
            return {
                ...initialState,
                search: action.payload,
            };
        }
        case generalChatActions.RESET: {
            return { ...initialState };
        }
        default:
            return state;
    }
};

export default generalChat;
